import { useFeatureFlags } from "../../context/flags";

/**
 * Feature flag for the notification centre (bell, side panel, What's new,
 * curve/price alert toasts) and incident banners (WEB-1356 / WEB-1860).
 *
 * Toggle per-environment via Hasura `feature_flags`, or override locally with:
 *   localStorage.setItem("feature-flag:notification-centre-and-incidents", "true")
 */
export const NOTIFICATION_CENTRE_AND_INCIDENTS_FLAG = "notification-centre-and-incidents";

export function useNotificationCentreEnabled(): boolean {
  const [flag] = useFeatureFlags(NOTIFICATION_CENTRE_AND_INCIDENTS_FLAG);
  return Boolean(flag);
}
